<template>
  <li  class="dashboard-item">
    <router-link class="dashboard-item_link" :to="item.to">
      <div class="icon">
        <component class="svg" :is="item.icon"></component>
      </div>
      <h2 class="name">{{item.name}}</h2>
      <h3 class="desc">{{item.desc}}</h3>
    </router-link>
  </li>
</template>

<script>
  export default {
    name: 'linkItem',
    props: {
      item: {
        type: Object
      }
    }
  }
</script>
